<template>
  <div id="app">
    <router-view />
    <LoadingAnimation :show="isLoading" :loading-text="loadingText" />
    <CopyToast :show="showToast" :copied-url="copiedUrl" />
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import LoadingAnimation from "@/components/LoadingAnimation.vue";
import CopyToast from "@/components/CopyToast.vue";
import { useLoading } from "@/composables/useLoading";
import { useCopyToast } from "@/composables/useCopyToast";

export default {
  name: "App",
  components: {
    LoadingAnimation,
    CopyToast,
  },
  setup() {
    const router = useRouter();
    const { isLoading, loadingText, showLoading, hideLoading } = useLoading();
    const { showToast, copiedUrl } = useCopyToast();

    let loadingTimer = null;

    // 监听路由变化
    router.beforeEach((to, from, next) => {
      if (from.name) {
        // 不是首次加载
        showLoading("页面跳转中");
      }
      next();
    });

    router.afterEach(() => {
      // 延迟关闭加载动画，确保页面渲染完成
      clearTimeout(loadingTimer);
      loadingTimer = setTimeout(() => {
        hideLoading();
      }, 600);
    });

    return {
      isLoading,
      loadingText,
      showToast,
      copiedUrl,
    };
  },
};
</script>

<style></style>
